/**
 * PublicClient — a bare axios client for anonymous reads: no Bearer token, no share session,
 * and no 401 → refresh → /login redirect.
 *
 * The shared `Client` refreshes on a 401 and bounces to /login; a reader of a public page
 * (a newsroom article, a chart drawn under a visualization grant) must never land on a
 * login screen because one request was refused. Sends the UI locale like `Client` does.
 */
import { getApiBaseUrl } from '@/app/runtime';
import i18n from '@/i18n';
import axios from 'axios';
import normalizeBaseDomain from './normalizeBaseDomain';

const request = axios.create({ baseURL: normalizeBaseDomain(getApiBaseUrl()) });

request.interceptors.request.use((config) => {
  config.headers ||= {};
  config.headers['Accept-Language'] = i18n.global.locale.value;
  return config;
});

export default request;
